import { Icon, StreamingIcons } from "@/components/atoms/Icon";
import { isIconOnly } from "@/utils/IsIconOnly";
import { useClassNames } from "@/utils/classNames";

import { ButtonProps, ButtonVariant, TVButtonProps } from "./types";
import styles from "./Button.module.scss";

/**
 * Button component that renders a styled HTML button with optional icon and text.
 *
 * @param props - The component props
 * @returns A button component
 */
const Button = ({
  variant = ButtonVariant.Primary,
  disabled = false,
  type = "button",
  onClick,
  children,
  className,
  ...rest
}: ButtonProps) => {
  const layout = "layout" in rest ? rest.layout : null;
  const selected = "selected" in rest ? rest.selected : null;

  /* If there is no text, add icon only styling */
  const iconOnly = isIconOnly(children);

  const cn = useClassNames(
    styles,
    styles["button"],
    styles[variant],
    layout && styles[layout],
    selected && styles["selected"],
    iconOnly && styles["icon-only"],
    className,
  );

  return (
    <button
      type={type}
      className={cn}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {variant == ButtonVariant.Locked && <Icon icon={StreamingIcons.Lock} />}
      {children}
    </button>
  );
};

export { Button };
